module.exports = __webpack_public_path__ + "static/media/page-hero-background.b7dec3f6.png";